import { createAction } from 'redux-act';

export const selectAllActions = {
  deselectAllOpportunities: createAction('Deselect all items in data lists'),
};
